module.exports = () => {
  if (process.env.REACT_APP_PLATFORM === 'say') {
    return 'Say';
  } else {
    return 'EdConnect';
  }
};
